import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSeed3dParams {
  /**
   * 内容数组，必填参数。必须同时包含文本内容（type为text）和图片内容（type为image_url）
   */
  content: Record<string, any>[];
}

export interface VolcesSeed3dResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_seed3d
 *
 * Volces Seed3D 1.0 3D Model Generator
 * 
 * 3D model generation implementation for Volces Seed3D 1.0 (火山引擎).
 * 
 * Model: ep-20251022222630-dg2jk
 * Features: 从单张图片和文本描述生成3D模型文件
 * Supported Formats: GLB, OBJ, PLY, STL
 * Subdivision Levels: low, medium, high
 * 
 * API Documentation: https://www.volcengine.com/docs/82379/1856293
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSeed3d } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesSeed3d({
 *   // 参数见 VolcesSeed3dParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSeed3dParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSeed3d(
  params: VolcesSeed3dParams,
): Promise<VolcesSeed3dResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 4000,
    maxAttempts: 90,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seed3d',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeed3dResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
